import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { RegressionRunSummary } from "./regression.types";
import { REGRESSION_COLORS } from "./regressionStatus";

interface Props {
  runs: RegressionRunSummary[];
}

const barColor = (run: RegressionRunSummary) => {
  if (run.broken > 0) return REGRESSION_COLORS.broken;
  if (run.failed > 0) return REGRESSION_COLORS.failed;
  return REGRESSION_COLORS.passed;
};

export const RegressionRunHistoryBar: React.FC<Props> = ({ runs }) => {
  if (runs.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No completed runs yet.
      </Typography>
    );
  }

  const avgPassRate = Math.round(
    (runs.reduce((sum, r) => sum + (r.totalScenarios ? r.passed / r.totalScenarios : 1), 0) / runs.length) * 100,
  );

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "flex-end", gap: "2px", height: 42 }}>
        {runs.map((run) => {
          const passRate = run.totalScenarios ? Math.round((run.passed / run.totalScenarios) * 100) : 100;
          return (
            <Tooltip
              key={run._id}
              title={`Run #${run.runNumber} — ${new Date(run.completedAt).toLocaleDateString()} — ${passRate}% pass (${run.passed}/${run.totalScenarios})`}
            >
              <Box
                sx={{
                  flex: "1 1 0",
                  minWidth: 2,
                  height: "100%",
                  borderRadius: "1.5px",
                  bgcolor: barColor(run),
                  cursor: "default",
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
        <Typography variant="caption" color="text.secondary">{runs.length} runs ago</Typography>
        <Typography variant="caption" color="text.secondary">{avgPassRate}% average pass rate</Typography>
        <Typography variant="caption" color="text.secondary">latest</Typography>
      </Box>
    </Box>
  );
};

export default RegressionRunHistoryBar;
